import _ from "lodash";
import { push } from "react-router-redux";
import axios from "axios";

import { localRequest } from "../../../apiUtils";
import { setLoading } from "../../app/actions";
import { getOptions } from "helpers/common";
import URLS from "constants/urlConstants";

export const actionTypes = {
  GET_ITEM_OPTIONS_REQUEST: "GET_ITEM_OPTIONS_REQUEST",
  GET_ITEM_OPTIONS_SUCCESS: "GET_ITEM_OPTIONS_SUCCESS",
  GET_CLASS_OPTIONS_REQUEST: "GET_CLASS_OPTIONS_REQUEST",
  GET_CLASS_OPTIONS_SUCCESS: "GET_CLASS_OPTIONS_SUCCESS",
  PREFERENCES_FAILURE: "PREFERENCES_FAILURE",
  GET_PREFERENCES_REQUEST: "GET_PREFERENCES_REQUEST",
  GET_PREFERENCES_SUCCESS: "GET_PREFERENCES_SUCCESS",
  ADD_PREFERENCES_SUCCESS: "ADD_PREFERENCES_SUCCESS",
  GET_PREFERENCES_SELECT_OPTIONS_REQUEST:
    "GET_PREFERENCES_SELECT_OPTIONS_REQUEST",
  GET_PREFERENCES_SELECT_OPTIONS_SUCCESS:
    "GET_PREFERENCES_SELECT_OPTIONS_SUCCESS"
};

export default class Actions {
  public static getPreferences() {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      try {
        const { data } = await localRequest.get(
          `settings/${getState().app.currentCustomer.Id}`
        );
        dispatch(success(data));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_PREFERENCES_REQUEST };
    }

    function success(payload) {
      return { type: actionTypes.GET_PREFERENCES_SUCCESS, payload };
    }

    function failure(error) {
      return { type: actionTypes.PREFERENCES_FAILURE, error };
    }
  }

  public static savePreferences(Settings: any) {
    return async (dispatch, getState) => {
      dispatch(setLoading(true));

      try {
        const params = {
          _id: _.get(getState(), "preferences.settings._id"),
          Customer: getState().app.currentCustomer.Id,
          Settings
        };
        const { data } = await localRequest.post("settings", params);
        dispatch(success(data));
        dispatch(setLoading(false));
        dispatch(push(URLS.MY_DELIVERIES_URL));
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(failure(error));
      }
    };

    function success(payload) {
      return { type: actionTypes.ADD_PREFERENCES_SUCCESS, payload };
    }

    function failure(error) {
      return { type: actionTypes.PREFERENCES_FAILURE, error };
    }
  }

  public static getItemOptions() {
    return async dispatch => {
      dispatch(request());

      const url =
        "Items?$filter=TypeId eq 'Packaging' and Active eq true and PortalActive eq true";

      try {
        const { data } = await axios.get(url);
        const capiItemOptions = _.get(data, "value", []);
        const itemOptions = _(capiItemOptions)
          .map(option => ({
            label: option.Description,
            value: option.Id,
            number: option.Number
          }))
          .sortBy("label")
          .value();
        dispatch(success(itemOptions));
      } catch (error) {
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_ITEM_OPTIONS_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_ITEM_OPTIONS_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.PREFERENCES_FAILURE, error };
    }
  }

  public static getClasses() {
    return async dispatch => {
      dispatch(request());

      const url =
        "ProductClasses?$filter=Active eq true&$select=Id,Code&$orderby=Code";

      try {
        const { data } = await axios.get(url);
        const capiClassOptions = _.get(data, "value", []);
        const classOptions = _(capiClassOptions)
          .map(item => ({
            label: item.Code,
            value: item.Id
          }))
          .sortBy("label")
          .value();
        dispatch(success(classOptions));
      } catch (error) {
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_CLASS_OPTIONS_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_CLASS_OPTIONS_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.PREFERENCES_FAILURE, error };
    }
  }

  public static getSelectOptions() {
    return async dispatch => {
      dispatch(request());

      try {
        const { data } = await axios.get("Shipments/Enums");
        const freightCosts = _(getOptions(data, "ShipmentFreightCosts"))
          .filter(f => f.value !== "Geen")
          .sortBy("label")
          .value();
        const amStatus = _(getOptions(data, "ShipmentLineAMStatus"))
          .filter(f => f.value !== "Geen")
          .sortBy("label")
          .value();
        const lineTypes = _(getOptions(data, "ShipmentLineType"))
          .filter(f => f.value !== "Correction")
          .sortBy("label")
          .value();
        const ownerTypes = _.sortBy(
          getOptions(data, "ShipmentFustLineOwnerType"),
          "label"
        );
        const transferTypes = _.sortBy(
          getOptions(data, "ShipmentFustLineTransferType"),
          "label"
        );

        dispatch(
          success({
            freightCosts,
            amStatus,
            lineTypes,
            ownerTypes,
            transferTypes
          })
        );
      } catch (error) {
        dispatch(failure(error));
      }
    };

    function request() {
      return { type: actionTypes.GET_PREFERENCES_SELECT_OPTIONS_REQUEST };
    }
    function success(payload) {
      return {
        type: actionTypes.GET_PREFERENCES_SELECT_OPTIONS_SUCCESS,
        payload
      };
    }
    function failure(error) {
      return { type: actionTypes.PREFERENCES_FAILURE, error };
    }
  }
}
